import { render } from "./RemoveConfigurationsFromListModal.vue?vue&type=template&id=b2511ea6&scoped=true"
import script from "./RemoveConfigurationsFromListModal.vue?vue&type=script&lang=js"
export * from "./RemoveConfigurationsFromListModal.vue?vue&type=script&lang=js"

import "./RemoveConfigurationsFromListModal.vue?vue&type=style&index=0&id=b2511ea6&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2511ea6"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QDialog});
